import gql from "graphql-tag";

export const GET_ALLFOLDER = gql`
query GetAllFolder($companyName: String!,  $sharedBy: String, $limit: Int, $offset: Int, $searchText: String, $order: String, $orderBy: String, $userId: JSONObject, $userRole: JSONObject) {
    getAllFolder(companyName: $companyName, limit: $limit, sharedBy: $sharedBy, offset: $offset, searchText: $searchText, order: $order, orderBy: $orderBy, userId: $userId, userRole: $userRole) {
    code
    success
    message
    results
    count
  }
}`;

export const CREATE_FOLDER= gql`
mutation CreateFolder($data: InputLibrary!, $fullName: String!, $companyName: String!) {
  createFolder(data: $data, fullName: $fullName, companyName: $companyName) {
    code
    success
    message
  }
}`;

export const UPDATE_FOLDER= gql`
mutation UpdateFolder($id: ID!, $data: InputLibrary!, $fullName: String!, $companyName: String!) {
  updateFolder(_id: $id, data: $data, fullName: $fullName, companyName: $companyName) {
    code
    success
    message
  }
}`;

export const DELETE_FOLDER= gql`
mutation DeleteFolder($id: ID!, $fullName: String!, $companyName: String!) {
  deleteFolder(_id: $id, fullName: $fullName, companyName: $companyName) {
    code
    success
    message
  }
}`;




